// extracted by mini-css-extract-plugin
export default {"wrapper":"a3HK8KfgD7dPvR1e8xbR"};